import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class StringToDateService {

  toDate(stringDate: string): Date {
    const day = stringDate.substring(0,2)
    const mount = stringDate.substring(3,5)
    const year = stringDate.substring(6,10)
    const hours = stringDate.substring(11,13)
    const minute = stringDate.substring(14,16)
    const second = stringDate.substring(17,19)
    return new Date(+year, +mount - 1, +day, +hours, +minute, +second)
  }

}
